<template>
  <div
    v-if="show_status"
    class="mr-14"
    style="grid-column-gap:1rem;display:grid;grid-template-columns: max-content max-content 1fr; align-items: center;"
  >
    <div class="text-left">
      {{ $n(status.current) + " KM" }} od
      {{ $n(status.max) + " KM" }}
    </div>
    <v-progress-linear
      height="20"
      rounded
      color="primary"
      background-color="rgba(0,0,0,0.10)"
      :value="status.max > 0 ? (status.current / status.max) * 100 : 0"
      style="width: 20rem;"
    >
    </v-progress-linear>
    {{
      $n(
        parseFloat(
          (status.current / (status.max > 0 ? status.max : 1)) * 100
        ).toFixed(2)
      )
    }}%
  </div>
  <div v-else>&nbsp;</div>
</template>
<script>
export default {
  props: {
    status: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show_status: false,
      selected_option: 0,
    };
  },
  watch: {
    status: {
      handler() {
        if (this.status !== null) {
          this.show_status = true;
        } else {
          this.show_status = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
